import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, Observable } from 'rxjs';

import { CanvasElementType, PaginableElementType } from '@blaze-runtime/engine-domain';
import { DataBindingSourceInfo, getActiveBinding } from '@blaze-shared/elements-domain';
import { BlazeSchema } from '@blaze-shared/schema-domain';

import { CanvasElementComponent } from '../../canvas-elements/element-component';
import { ContainerActionsService } from '../../services/container-actions.service';

import { CanvasElementBaseComponent } from './base.component';

type ElementsWithActions = Extract<CanvasElementType, PaginableElementType | 'kanbanBoard'>;

@UntilDestroy()
@Component({
  template: '',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class CanvasElementBaseWithActionsComponent<T extends ElementsWithActions>
  extends CanvasElementBaseComponent<T>
  implements CanvasElementComponent<T>
{
  protected readonly containerActionsService = inject(ContainerActionsService);

  protected dataValue = this.getDataInput('value');
  protected schema$: Observable<BlazeSchema>;

  abstract value: any[];

  idColumnName?: string;

  get propsDataSource(): DataBindingSourceInfo | undefined {
    return getActiveBinding(this.props?.data, 'value')?.dataSource;
  }

  constructor() {
    super();

    this.schema$ = this.dataValue.schema$.pipe(filter(Boolean));
    this.schema$.pipe(untilDestroyed(this)).subscribe((schema: BlazeSchema) => {
      this.idColumnName = schema.columns.find((col) => col.isId)?.name;
    });
  }
}
